export const getDossierStageFilter = state => state.dossierStage.filter
